import { WINDOW_AT_500, REDUCERS } from '../../constants.js';

const initialWindowVisible = {
  reducer_type: REDUCERS.WINDOW_VISIBLE,
  windowVisible: WINDOW_AT_500.NONE
};

const windowVisible500 = (state = initialWindowVisible, action) => {
  switch (action.type) {
    case WINDOW_AT_500.NONE:
      return  { windowVisible: WINDOW_AT_500.NONE };
    case WINDOW_AT_500.MESSAGE:
      if(state.windowVisible === WINDOW_AT_500.MESSAGE){
        return  { windowVisible: WINDOW_AT_500.NONE };
      }
      return { windowVisible: WINDOW_AT_500.MESSAGE };
    case WINDOW_AT_500.CALL:
      if(state.windowVisible === WINDOW_AT_500.CALL){
        return  { windowVisible: WINDOW_AT_500.NONE };
      }
      return { windowVisible: WINDOW_AT_500.CALL };
    default:
      return state;
  }
}
export default windowVisible500;



// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_window_visible500.js